












import { Component, Vue } from 'vue-property-decorator';
import { ModalType } from '@/contract/modal.contract';
import { VueConstructor } from 'vue';
import displayStore from '@/store/modules/display/displayStore';
import BaseModal from './BaseModal.vue';
import MessageModal from './MessageModal.vue';

@Component({})
export default class AllModals extends Vue {
  private baseModalId = 'bucp-modal';
  public get modalsModel() {
    return displayStore.state.modalsModel;
  }

  private get allModals(): Array<{ modalType: ModalType; modal: VueConstructor }> {
    return [
      { modalType: 'default', modal: BaseModal },
      { modalType: 'message', modal: MessageModal },
    ];
  }

  public updateModalState(modalType: ModalType, isOpen: boolean) {
    displayStore.commit.SET_MODAL_STATE({ modalType: modalType, state: { isOpen } });
  }

  private getId(modalType: ModalType) {
    return `${this.baseModalId}-${modalType}`;
  }
}
